function HTMLStrip (str) {
	const div = document.createElement('div')
	div.innerHTML = str

	return div.textContent || div.innerText
}

export { HTMLStrip }
